'use client';
import React, { useState, useEffect } from 'react';
import { trackPageView, trackClick, trackAppDownload, trackMetaPixelDownload } from '@/lib/analytics';

const DOWNLOAD_URL =
'https://wn5r3rjrpri4yg2pejjnvh7q4m0ywcds.lambda-url.eu-west-3.on.aws/l7cjmDFZBnj';

interface PrizeCard {
  id: string;
  category: 'auto' | 'tech' | 'lifestyle';
  tag: string;
  tagLight?: boolean;
  imageUrl: string;
  imageAlt: string;
  imageNote: string;
  imageClass: string;
  categoryLabel: string;
  title: string;
  description: string;
  availability: string;
  price: string;
}

const prizes: PrizeCard[] = [
{
  id: 'bmw',
  category: 'auto',
  tag: 'LE GRAND LOT',
  tagLight: false,
  imageUrl: 'https://chance-ci-ivoire.laicai66877.chatgpt.site/assets/bmw.jpg',
  imageAlt: 'BMW Série 5, illustration du prix envisagé',
  imageNote: 'Visuel illustratif',
  imageClass: 'car-image',
  categoryLabel: 'AUTOMOBILE',
  title: 'BMW Série 5',
  description: 'Un nouveau départ, en grand.',
  availability: 'Modèle et livraison à confirmer',
  price: '85 FCFA'
},
{
  id: 'iphone',
  category: 'tech',
  tag: 'À L\'ÉTUDE',
  tagLight: true,
  imageUrl: 'https://chance-ci-ivoire.laicai66877.chatgpt.site/assets/iphone.jpg',
  imageAlt: 'iPhone de génération précédente, illustration uniquement',
  imageNote: 'Autre génération illustrée',
  imageClass: 'phone-image',
  categoryLabel: 'HIGH-TECH',
  title: 'iPhone 18 Pro',
  description: 'Votre prochain favori, peut-être.',
  availability: 'Lot envisagé · disponibilité non confirmée',
  price: '85 FCFA'
},
{
  id: 'audio',
  category: 'tech',
  tag: 'LA SÉLECTION',
  tagLight: true,
  imageUrl: 'https://chance-ci-ivoire.laicai66877.chatgpt.site/assets/audio.jpg',
  imageAlt: 'Casque audio, illustration du lot high-tech envisagé',
  imageNote: 'Visuel illustratif',
  imageClass: 'audio-image',
  categoryLabel: 'HIGH-TECH',
  title: 'Casque premium',
  description: 'Votre musique, autrement.',
  availability: 'Marque et modèle à confirmer',
  price: '85 FCFA'
},
{
  id: 'macbook',
  category: 'tech',
  tag: 'NOUVEAU',
  tagLight: true,
  imageUrl: 'https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=800&q=80',
  imageAlt: 'MacBook Pro, illustration du lot high-tech envisagé',
  imageNote: 'Visuel illustratif',
  imageClass: 'laptop-image',
  categoryLabel: 'HIGH-TECH',
  title: 'MacBook Pro M4',
  description: 'La puissance à portée de main.',
  availability: 'Modèle et configuration à confirmer',
  price: '85 FCFA'
},
{
  id: 'watch',
  category: 'tech',
  tag: 'À L\'ÉTUDE',
  tagLight: true,
  imageUrl: 'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=800&q=80',
  imageAlt: 'Montre connectée Apple Watch, illustration du lot high-tech envisagé',
  imageNote: 'Visuel illustratif',
  imageClass: 'watch-image',
  categoryLabel: 'HIGH-TECH',
  title: 'Apple Watch Ultra',
  description: 'Le temps, redéfini.',
  availability: 'Modèle et couleur à confirmer',
  price: '85 FCFA'
},
{
  id: 'moto',
  category: 'auto',
  tag: 'LA SÉLECTION',
  tagLight: true,
  imageUrl: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80',
  imageAlt: 'Moto Yamaha, illustration du lot automobile envisagé',
  imageNote: 'Visuel illustratif',
  imageClass: 'moto-image',
  categoryLabel: 'AUTOMOBILE',
  title: 'Yamaha NMAX 155',
  description: 'La liberté sur deux roues.',
  availability: 'Modèle et couleur à confirmer',
  price: '85 FCFA'
},
{
  id: 'tv',
  category: 'tech',
  tag: 'NOUVEAU',
  tagLight: true,
  imageUrl: 'https://images.unsplash.com/photo-1593359677879-a4bb92f829d1?w=800&q=80',
  imageAlt: 'Smart TV Samsung 75 pouces, illustration du lot high-tech envisagé',
  imageNote: 'Visuel illustratif',
  imageClass: 'tv-image',
  categoryLabel: 'HIGH-TECH',
  title: 'Smart TV 75"',
  description: 'Le cinéma chez vous.',
  availability: 'Marque et modèle à confirmer',
  price: '85 FCFA'
},
{
  id: 'samsung',
  category: 'tech',
  tag: 'À L\'ÉTUDE',
  tagLight: true,
  imageUrl: 'https://images.unsplash.com/photo-1610945415295-d9bbf067e59c?w=800&q=80',
  imageAlt: 'Samsung Galaxy S25 Ultra, illustration du lot high-tech envisagé',
  imageNote: 'Visuel illustratif',
  imageClass: 'phone-image',
  categoryLabel: 'HIGH-TECH',
  title: 'Samsung Galaxy S25',
  description: 'L\'innovation Android au sommet.',
  availability: 'Lot envisagé · disponibilité non confirmée',
  price: '85 FCFA'
},
{
  id: 'cash',
  category: 'lifestyle',
  tag: 'SPÉCIAL',
  tagLight: false,
  imageUrl: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&q=80',
  imageAlt: 'Enveloppe de cash, illustration du lot financier envisagé',
  imageNote: 'Visuel illustratif',
  imageClass: 'cash-image',
  categoryLabel: 'CASH',
  title: '5 000 000 FCFA',
  description: 'Virement direct sur votre compte.',
  availability: 'Modalités de versement à confirmer',
  price: '85 FCFA'
}];


type FilterType = 'all' | 'auto' | 'tech' | 'lifestyle';

export default function ChanceCIPage() {
  const [activeFilter, setActiveFilter] = useState<FilterType>('all');
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [showNumeros, setShowNumeros] = useState(false);
  const [showRegles, setShowRegles] = useState(false);
  const [geoResult, setGeoResult] = useState<{ ip: string; country?: string } | null>(null);

  useEffect(() => {
    fetch('https://ipapi.co/json/')
      .then((r) => r.json())
      .then((data) => setGeoResult({ ip: data.ip, country: data.country_name }))
      .catch(() => null);
  }, []);

  // Track page view on mount
  useEffect(() => {
    trackPageView();
  }, []);

  const filteredPrizes = prizes.filter((p) =>
  activeFilter === 'all' ? true : p.category === activeFilter
  );

  const filterCounts = {
    all: prizes.length,
    auto: prizes.filter((p) => p.category === 'auto').length,
    tech: prizes.filter((p) => p.category === 'tech').length,
    lifestyle: prizes.filter((p) => p.category === 'lifestyle').length
  };

  const faqs = [
  {
    q: 'Combien coûte une participation ?',
    a: 'Le tarif est de 85 FCFA par participation. Par exemple, 2 participations correspondent à 170 FCFA. Cette démonstration ne prélève aucun argent.'
  },
  {
    q: 'Est-ce une activité officielle de Wave ?',
    a: 'Non. Chance CI est un concept indépendant. Wave est le moyen de paiement envisagé, sous réserve d\'acceptation du service. Aucune affiliation ou autorisation de Wave n\'est revendiquée.'
  },
  {
    q: 'Peut-on déjà participer pour de vrai ?',
    a: 'Non. Cette page est un prototype. Les paiements et les numéros sont fictifs. L\'ouverture dépend notamment des autorisations applicables, de l\'accord du prestataire de paiement et de la disponibilité des lots.'
  },
  {
    q: 'Comment seront organisés les tirages ?',
    a: 'Les dates, le nombre de lots, les probabilités, les modalités de tirage et de remboursement devront être publiés avant toute collecte de fonds. Aucun tirage réel n\'est organisé ici.'
  }];


  return (
    <>
      {/* Demo bar */}
      <div className="demo-bar">
        <span>APERÇU DU CONCEPT</span> Démonstration uniquement · Aucun paiement réel
      </div>

      {/* IP display bar */}
      {geoResult && (
        <div style={{
          background: '#0f2330', borderBottom: '1px solid #1e3a4a',
          padding: '6px 0', textAlign: 'center'
        }}>
          <span style={{ color: '#4a7080', fontSize: 11, fontWeight: 600, letterSpacing: 0.5 }}>
            🌐 Votre IP :&nbsp;
          </span>
          <span style={{ color: '#aaffce', fontSize: 12, fontWeight: 700, fontFamily: 'monospace' }}>
            {geoResult.ip}
          </span>
          {geoResult.country && geoResult.country !== 'LOCAL' && (
            <span style={{ color: '#6b8fa0', fontSize: 11, marginLeft: 8 }}>
              · {geoResult.country}
            </span>
          )}
        </div>
      )}

      {/* Header */}
      <header className="header wrap">
        <a className="brand" href="#" aria-label="Chance CI accueil">
          chance<span className="brand-dot">.</span><span className="ci">CI</span>
        </a>
        <nav className="desktop-nav" aria-label="Navigation principale">
          <a className="active" href="#lots">Les lots</a>
          <a href="#comment">Comment ça marche</a>
          <button className="text-button" onClick={() => setShowRegles(true)}>Les règles</button>
        </nav>
        <div className="header-right">
          <span className="country">
            <span className="country-flag" aria-hidden="true" />
            Côte d&apos;Ivoire
          </span>
          <button className="account" onClick={() => setShowNumeros(true)}>
            <span aria-hidden="true">◫</span> Mes participations
          </button>
        </div>
      </header>

      <main className="wrap">
        {/* Hero */}
        <section className="hero" aria-labelledby="hero-title">
          <div className="hero-photo">
            <img
              src="https://chance-ci-ivoire.laicai66877.chatgpt.site/assets/bmw.jpg"
              alt="BMW Série 5 — visuel illustratif du lot automobile envisagé" />
            
          </div>
          <div className="hero-copy">
            <div className="eyebrow">
              <span className="mini-star">✦</span> DE GRANDS RÊVES. UNE PETITE MISE.
            </div>
            <h1 id="hero-title">
              Et si la prochaine<br />
              était <em>la vôtre&nbsp;?</em>
            </h1>
            <p className="hero-desc">
              Une BMW Série 5. Des lots d&apos;exception.<br />
              Votre prochaine belle surprise commence ici.
            </p>
            <a
              href={DOWNLOAD_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-mint"
              onClick={() => { trackClick('hero_decouvrir_bmw'); trackAppDownload(); trackMetaPixelDownload(); }}
            >
              Découvrir la BMW <span className="arrow">↗</span>
            </a>
            <div className="hero-price">
              <strong>85 FCFA</strong>
              <span>
                par participation<br />
                Tarif de démonstration
              </span>
            </div>
          </div>
          <div className="hero-label">
            <span>LE GRAND LOT ENVISAGÉ</span>
            <strong>BMW Série 5</strong>
            <p>Le plaisir de voir plus grand.</p>
          </div>
          <span className="hero-caption">Visuel illustratif · Modèle et disponibilité à confirmer</span>
          <div className="hero-index">
            <span>01</span>
            <div />
            LE GRAND LOT
          </div>
        </section>

        {/* Assurance bar */}
        <section className="assurance" aria-label="Informations de participation">
          <div>
            <span className="line-icon">↗</span>
            <p>
              <strong>Simple avec Wave</strong>
              <small>Un parcours de paiement familier</small>
            </p>
          </div>
          <div>
            <span className="line-icon">◈</span>
            <p>
              <strong>Des règles accessibles</strong>
              <small>Les conditions avant de participer</small>
            </p>
          </div>
          <div>
            <span className="line-icon">◫</span>
            <p>
              <strong>Tout au même endroit</strong>
              <small>Vos numéros et vos participations</small>
            </p>
          </div>
        </section>

        {/* Lots section */}
        <section id="lots" className="lots-section">
          <div className="section-heading">
            <div>
              <div className="eyebrow dark">LE PROCHAIN SOURIRE POURRAIT ÊTRE LE VÔTRE</div>
              <h2>Quel est votre coup de cœur&nbsp;?</h2>
            </div>
            <span className="count-label">{filterCounts.all} lots envisagés</span>
          </div>

          <div className="filter-row" role="group" aria-label="Filtrer les lots">
            <button
              className={`filter${activeFilter === 'all' ? ' selected' : ''}`}
              onClick={() => setActiveFilter('all')}
              aria-pressed={activeFilter === 'all'}>
              
              Tous les lots <span>{filterCounts.all}</span>
            </button>
            <button
              className={`filter${activeFilter === 'auto' ? ' selected' : ''}`}
              onClick={() => setActiveFilter('auto')}
              aria-pressed={activeFilter === 'auto'}>
              
              Automobile
            </button>
            <button
              className={`filter${activeFilter === 'tech' ? ' selected' : ''}`}
              onClick={() => setActiveFilter('tech')}
              aria-pressed={activeFilter === 'tech'}>
              
              High-tech
            </button>
            <button
              className={`filter${activeFilter === 'lifestyle' ? ' selected' : ''}`}
              onClick={() => setActiveFilter('lifestyle')}
              aria-pressed={activeFilter === 'lifestyle'}>
              
              Cash & Lifestyle
            </button>
            <span className="filter-note">Collection de démonstration</span>
          </div>

          <div className="prize-grid">
            {filteredPrizes.map((prize) =>
            <article key={prize.id} className="prize-card" data-category={prize.category}>
                <div className={`prize-image ${prize.imageClass}`}>
                  <span className={`tag${prize.tagLight ? ' light' : ''}`}>{prize.tag}</span>
                  <img
                  src={prize.imageUrl}
                  alt={prize.imageAlt}
                  loading="lazy" />
                
                  <span className="image-note">{prize.imageNote}</span>
                </div>
                <div className="prize-body">
                  <div className="prize-category">{prize.categoryLabel}</div>
                  <h3>{prize.title}</h3>
                  <p>{prize.description}</p>
                  <div className="availability">
                    <span>{prize.availability}</span>
                  </div>
                  <div className="prize-bottom">
                    <div>
                      <strong>
                        {prize.price} <small>/ participation</small>
                      </strong>
                      <span>Paiement Wave simulé</span>
                    </div>
                    <a
                    href={DOWNLOAD_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="square-button"
                    aria-label={`Voir le lot ${prize.title}`}
                    onClick={() => { trackClick(`prize_card_${prize.id}`); trackAppDownload(); trackMetaPixelDownload(); }}
                    >
                      ↗
                    </a>
                  </div>
                </div>
              </article>
            )}
          </div>
        </section>

        {/* How it works */}
        <section className="how" id="comment">
          <div className="how-intro">
            <span className="eyebrow dark">C&apos;EST AUSSI SIMPLE QUE ÇA</span>
            <h2>
              Trois étapes.<br />
              Et un peu de chance.
            </h2>
            <p>
              Un parcours clair, du choix de votre lot<br />
              à votre numéro de participation.
            </p>
            <button className="link-button" onClick={() => setShowRegles(true)}>
              Lire les règles du concept <span>↗</span>
            </button>
          </div>
          <div className="steps">
            <article>
              <span>01</span>
              <div>
                <h3>Trouvez votre favori</h3>
                <p>Découvrez le lot, son prix et les conditions de participation.</p>
              </div>
            </article>
            <article>
              <span>02</span>
              <div>
                <h3>Passez par Wave</h3>
                <p>Confirmez votre choix dans le parcours de paiement. Ici, tout est simulé.</p>
              </div>
            </article>
            <article>
              <span>03</span>
              <div>
                <h3>Gardez votre numéro</h3>
                <p>Retrouvez votre participation et les informations de tirage au même endroit.</p>
              </div>
            </article>
          </div>
        </section>

        {/* Download CTA */}
        <section className="download-section">
          <div className="dl-inner-wrap">
            <div className="dl-eyebrow">
              <span>✦</span> DISPONIBLE MAINTENANT
            </div>
            <h2 className="dl-headline">
              Votre chance de<br />
              <em>changer de vie</em><br />
              est dans votre poche.
            </h2>
            <p className="dl-sub">
              Téléchargez l&apos;application <strong style={{ color: '#d4ede8', fontWeight: 600 }}>Chance CI</strong> et participez à des tirages
              exclusifs depuis votre smartphone. Simple, rapide, sécurisé — à portée de main.
            </p>
            <div>
              <a
                href={DOWNLOAD_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="dl-cta-btn"
                onClick={() => { trackClick('download_cta'); trackAppDownload(); trackMetaPixelDownload(); }}
              >
                
                <span style={{ fontSize: 24 }}>📲</span>
                Télécharger l&apos;APP
              </a>
            </div>
            <p className="dl-trust">
              <span style={{ color: '#aaffce' }}>🔒</span>
              Téléchargement gratuit · Sécurisé · Aucun abonnement requis
            </p>
          </div>
        </section>

        {/* FAQ */}
        <section className="faq">
          <div>
            <span className="eyebrow dark">ON VOUS RÉPOND</span>
            <h2>Tout simplement.</h2>
          </div>
          <div className="faq-items">
            {faqs.map((faq, i) =>
            <details
              key={i}
              open={openFaq === i}
              onToggle={(e) => {
                const det = e.currentTarget as HTMLDetailsElement;
                setOpenFaq(det.open ? i : null);
              }}>
              
                <summary>{faq.q}</summary>
                <p>{faq.a}</p>
              </details>
            )}
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer>
        <div className="wrap footer-main">
          <a className="brand" href="#">
            chance<span className="brand-dot">.</span><span className="ci">CI</span>
          </a>
          <p>Un peu de chance. Beaucoup de possibilités.</p>
          <button className="text-button" onClick={() => setShowRegles(true)}>Conditions du prototype</button>
        </div>
        <div className="wrap footer-bottom">
          <span>© 2026 Chance CI · Concept indépendant</span>
          <span>Participation réservée aux personnes éligibles · Jouez avec modération</span>
        </div>
      </footer>

      {/* Mobile nav */}
      <nav className="mobile-nav" aria-label="Navigation mobile">
        <a href="#lots"><span>◈</span>Les lots</a>
        <a href="#comment"><span>①</span>Comment</a>
        <button onClick={() => setShowNumeros(true)}><span>◫</span>Mes numéros</button>
        <button onClick={() => setShowRegles(true)}><span>ⓘ</span>Les règles</button>
      </nav>

      {/* Mes numéros modal */}
      {showNumeros && (
        <div
          style={{
            position: 'fixed', inset: 0, zIndex: 1000,
            background: 'rgba(10,20,26,0.85)', backdropFilter: 'blur(6px)',
            display: 'flex', alignItems: 'flex-end', justifyContent: 'center'
          }}
          onClick={() => setShowNumeros(false)}
        >
          <div
            style={{
              background: '#0d1b24', borderRadius: '20px 20px 0 0',
              width: '100%', maxWidth: 540, maxHeight: '85vh',
              overflowY: 'auto', padding: '0 0 32px 0',
              boxShadow: '0 -8px 40px rgba(0,0,0,0.5)'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Handle */}
            <div style={{ display: 'flex', justifyContent: 'center', padding: '14px 0 8px' }}>
              <div style={{ width: 40, height: 4, borderRadius: 2, background: '#2a3d4a' }} />
            </div>
            {/* Header */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 24px 16px' }}>
              <div>
                <h2 style={{ color: '#e8f4f0', fontSize: 20, fontWeight: 700, margin: 0 }}>Mes numéros</h2>
                <p style={{ color: '#6b8fa0', fontSize: 13, margin: '4px 0 0' }}>Participations par tirage · illimité par jour</p>
              </div>
              <button
                onClick={() => setShowNumeros(false)}
                style={{ background: '#1a2e3a', border: 'none', color: '#aaffce', borderRadius: 8, width: 36, height: 36, fontSize: 18, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              >×</button>
            </div>

            {/* Info banner */}
            <div style={{ margin: '0 24px 20px', background: '#0f2330', border: '1px solid #1e3a4a', borderRadius: 12, padding: '12px 16px', display: 'flex', gap: 10, alignItems: 'flex-start' }}>
              <span style={{ fontSize: 18, flexShrink: 0 }}>ℹ️</span>
              <p style={{ color: '#8ab4c4', fontSize: 13, margin: 0, lineHeight: 1.5 }}>
                Vous pouvez participer autant de fois que vous le souhaitez chaque jour. Chaque tirage génère un numéro unique. Vos numéros sont regroupés par tirage ci-dessous.
              </p>
            </div>

            {/* Draw groups */}
            <div style={{ padding: '0 24px', display: 'flex', flexDirection: 'column', gap: 16 }}>

              {/* Draw 1 */}
              <div style={{ background: '#0f2330', borderRadius: 14, overflow: 'hidden', border: '1px solid #1e3a4a' }}>
                <div style={{ padding: '14px 16px', borderBottom: '1px solid #1e3a4a', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ color: '#aaffce', fontSize: 12, fontWeight: 700, letterSpacing: 1 }}>TIRAGE #001</div>
                    <div style={{ color: '#e8f4f0', fontSize: 15, fontWeight: 600, marginTop: 2 }}>BMW Série 5 — Grand Lot</div>
                    <div style={{ color: '#6b8fa0', fontSize: 12, marginTop: 2 }}>Aujourd&apos;hui · 3 participations</div>
                  </div>
                  <span style={{ background: '#1a3a2a', color: '#aaffce', fontSize: 11, fontWeight: 700, padding: '4px 10px', borderRadius: 20 }}>EN COURS</span>
                </div>
                <div style={{ padding: '12px 16px', display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                  {['A-4821', 'A-4822', 'A-4823'].map((num) => (
                    <div key={num} style={{ background: '#162b38', border: '1px solid #2a4a5a', borderRadius: 8, padding: '8px 14px', textAlign: 'center' }}>
                      <div style={{ color: '#aaffce', fontSize: 16, fontWeight: 700, letterSpacing: 2 }}>{num}</div>
                      <div style={{ color: '#4a7080', fontSize: 10, marginTop: 2 }}>85 FCFA</div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Draw 2 */}
              <div style={{ background: '#0f2330', borderRadius: 14, overflow: 'hidden', border: '1px solid #1e3a4a' }}>
                <div style={{ padding: '14px 16px', borderBottom: '1px solid #1e3a4a', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ color: '#aaffce', fontSize: 12, fontWeight: 700, letterSpacing: 1 }}>TIRAGE #002</div>
                    <div style={{ color: '#e8f4f0', fontSize: 15, fontWeight: 600, marginTop: 2 }}>iPhone 18 Pro</div>
                    <div style={{ color: '#6b8fa0', fontSize: 12, marginTop: 2 }}>Aujourd&apos;hui · 2 participations</div>
                  </div>
                  <span style={{ background: '#1a3a2a', color: '#aaffce', fontSize: 11, fontWeight: 700, padding: '4px 10px', borderRadius: 20 }}>EN COURS</span>
                </div>
                <div style={{ padding: '12px 16px', display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                  {['B-1104', 'B-1105'].map((num) => (
                    <div key={num} style={{ background: '#162b38', border: '1px solid #2a4a5a', borderRadius: 8, padding: '8px 14px', textAlign: 'center' }}>
                      <div style={{ color: '#aaffce', fontSize: 16, fontWeight: 700, letterSpacing: 2 }}>{num}</div>
                      <div style={{ color: '#4a7080', fontSize: 10, marginTop: 2 }}>85 FCFA</div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Draw 3 - past */}
              <div style={{ background: '#0a1a22', borderRadius: 14, overflow: 'hidden', border: '1px solid #162a36', opacity: 0.7 }}>
                <div style={{ padding: '14px 16px', borderBottom: '1px solid #162a36', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ color: '#4a7080', fontSize: 12, fontWeight: 700, letterSpacing: 1 }}>TIRAGE #000</div>
                    <div style={{ color: '#8ab4c4', fontSize: 15, fontWeight: 600, marginTop: 2 }}>MacBook Pro M4</div>
                    <div style={{ color: '#4a7080', fontSize: 12, marginTop: 2 }}>Hier · 5 participations</div>
                  </div>
                  <span style={{ background: '#1a2a34', color: '#4a7080', fontSize: 11, fontWeight: 700, padding: '4px 10px', borderRadius: 20 }}>TERMINÉ</span>
                </div>
                <div style={{ padding: '12px 16px', display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                  {['C-0071', 'C-0072', 'C-0073', 'C-0074', 'C-0075'].map((num) => (
                    <div key={num} style={{ background: '#0f2028', border: '1px solid #1a3040', borderRadius: 8, padding: '8px 14px', textAlign: 'center' }}>
                      <div style={{ color: '#4a7080', fontSize: 16, fontWeight: 700, letterSpacing: 2 }}>{num}</div>
                      <div style={{ color: '#2a4050', fontSize: 10, marginTop: 2 }}>85 FCFA</div>
                    </div>
                  ))}
                </div>
              </div>

            </div>

            {/* CTA */}
            <div style={{ padding: '20px 24px 0' }}>
              <a
                href={DOWNLOAD_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, background: '#aaffce', color: '#0a1a22', borderRadius: 12, padding: '14px', fontWeight: 700, fontSize: 15, textDecoration: 'none' }}
                onClick={() => { trackClick('numeros_modal_download'); trackAppDownload(); trackMetaPixelDownload(); }}
              >
                <span>📲</span> Télécharger l&apos;APP pour participer
              </a>
            </div>
          </div>
        </div>
      )}

      {/* Les règles modal */}
      {showRegles && (
        <div
          style={{
            position: 'fixed', inset: 0, zIndex: 1000,
            background: 'rgba(10,20,26,0.85)', backdropFilter: 'blur(6px)',
            display: 'flex', alignItems: 'flex-end', justifyContent: 'center'
          }}
          onClick={() => setShowRegles(false)}
        >
          <div
            style={{
              background: '#0d1b24', borderRadius: '20px 20px 0 0',
              width: '100%', maxWidth: 540, maxHeight: '85vh',
              overflowY: 'auto', padding: '0 0 32px 0',
              boxShadow: '0 -8px 40px rgba(0,0,0,0.5)'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Handle */}
            <div style={{ display: 'flex', justifyContent: 'center', padding: '14px 0 8px' }}>
              <div style={{ width: 40, height: 4, borderRadius: 2, background: '#2a3d4a' }} />
            </div>
            {/* Header */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 24px 20px' }}>
              <div>
                <h2 style={{ color: '#e8f4f0', fontSize: 20, fontWeight: 700, margin: 0 }}>Les règles</h2>
                <p style={{ color: '#6b8fa0', fontSize: 13, margin: '4px 0 0' }}>Conditions de participation au concept</p>
              </div>
              <button
                onClick={() => setShowRegles(false)}
                style={{ background: '#1a2e3a', border: 'none', color: '#aaffce', borderRadius: 8, width: 36, height: 36, fontSize: 18, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              >×</button>
            </div>

            {/* Rules content */}
            <div style={{ padding: '0 24px', display: 'flex', flexDirection: 'column', gap: 16 }}>

              {[
                {
                  icon: '🎟️',
                  title: 'Participation',
                  text: 'Chaque participation coûte 85 FCFA. Vous pouvez participer autant de fois que vous le souhaitez par jour, à condition d\'avoir le solde suffisant. Chaque participation génère un numéro unique par tirage.'
                },
                {
                  icon: '🔢',
                  title: 'Numéros par tirage',
                  text: 'Vos numéros sont attribués par tirage. Un même tirage peut regrouper plusieurs de vos numéros si vous avez participé plusieurs fois. Il n\'y a pas de limite quotidienne de participations.'
                },
                {
                  icon: '🎯',
                  title: 'Tirages',
                  text: 'Les tirages sont organisés selon un calendrier publié à l\'avance. Les dates, modalités et probabilités de gain sont communiquées avant chaque tirage. Les résultats sont définitifs.'
                },
                {
                  icon: '💳',
                  title: 'Paiement',
                  text: 'Le paiement s\'effectue via Wave. Le montant est débité au moment de la participation. Aucun remboursement n\'est possible après validation de la participation.'
                },
                {
                  icon: '🏆',
                  title: 'Lots',
                  text: 'Les lots présentés sont indicatifs. Les modèles, couleurs et configurations exacts seront confirmés avant chaque tirage. La valeur des lots peut varier selon la disponibilité.'
                },
                {
                  icon: '⚖️',
                  title: 'Éligibilité',
                  text: 'La participation est réservée aux personnes majeures résidant en Côte d\'Ivoire. Chance CI se réserve le droit de vérifier l\'éligibilité des participants avant la remise des lots.'
                },
                {
                  icon: '⚠️',
                  title: 'Avertissement',
                  text: 'Cette page est un prototype de démonstration. Aucun paiement réel n\'est effectué. Aucun tirage réel n\'est organisé. Jouez avec modération — le jeu peut créer une dépendance.'
                }
              ].map((rule, i) => (
                <div key={i} style={{ background: '#0f2330', borderRadius: 12, padding: '16px', border: '1px solid #1e3a4a', display: 'flex', gap: 14, alignItems: 'flex-start' }}>
                  <span style={{ fontSize: 22, flexShrink: 0, marginTop: 2 }}>{rule.icon}</span>
                  <div>
                    <div style={{ color: '#aaffce', fontSize: 13, fontWeight: 700, marginBottom: 6, letterSpacing: 0.5 }}>{rule.title.toUpperCase()}</div>
                    <p style={{ color: '#8ab4c4', fontSize: 14, margin: 0, lineHeight: 1.6 }}>{rule.text}</p>
                  </div>
                </div>
              ))}

            </div>

            {/* Footer note */}
            <div style={{ margin: '20px 24px 0', background: '#0a1a22', borderRadius: 10, padding: '12px 16px', border: '1px solid #162a36' }}>
              <p style={{ color: '#4a7080', fontSize: 12, margin: 0, textAlign: 'center', lineHeight: 1.5 }}>
                © 2026 Chance CI · Concept indépendant · Aucune affiliation avec Wave ou toute autre entité
              </p>
            </div>
          </div>
        </div>
      )}
    </>);

}